const PUBLIC_ROUTE_URL = `${process.env.PUBLIC_URL}`;
export const ROUTES = {
  HOME: "/",
  HOMEPAGE: PUBLIC_ROUTE_URL,
  APPLYFORKENDRA: PUBLIC_ROUTE_URL + "/apply-for-kendra",
  LOGINFORKENDRA: PUBLIC_ROUTE_URL + "/login-to-kendra",
  DASHBOARDLOGIN: PUBLIC_ROUTE_URL + "/login",
  FORGETPASSWORD: PUBLIC_ROUTE_URL + "/forgot-password",
  RESET_PASSWORD: PUBLIC_ROUTE_URL + "/reset-password",
  KENDRA_REGISTRATION: PUBLIC_ROUTE_URL + "/kendra-registration",
  OTPVERIFICATION: PUBLIC_ROUTE_URL + "/otp-verification",
  RECRUITMENT: PUBLIC_ROUTE_URL + "/recruitment",
  RECRUITMENTFORM: PUBLIC_ROUTE_URL + "/recruitment-form/:id",
  GOVERNANCE: PUBLIC_ROUTE_URL + "/governance-council",
  EXECUTIVE: PUBLIC_ROUTE_URL + "/executive-council",
  ORGANIZATION: PUBLIC_ROUTE_URL + "/organization-chart",
  MANAGEMENT: PUBLIC_ROUTE_URL + "/management-team",
  PRODUCTPORTFOLIO: PUBLIC_ROUTE_URL + "/productportfolio/:name",
  TENDER: PUBLIC_ROUTE_URL + "/tender-details",
  DEBBAREDLIST: PUBLIC_ROUTE_URL + "/debarred-list",
  AWARDEDLIST: PUBLIC_ROUTE_URL + "/awarded-list",
  BLACKLIST: PUBLIC_ROUTE_URL + "/black-list",
  REVOCATIONORDER: PUBLIC_ROUTE_URL + "/revocation-order",
  ABOUTUS: PUBLIC_ROUTE_URL + "/about-us",
  LOCATEKENDRA: PUBLIC_ROUTE_URL + "/locate-kendra",
  LOCATEDISTRIBUTOR: PUBLIC_ROUTE_URL + "/locate-distributor",
  PMHOSPITAL: PUBLIC_ROUTE_URL + "/pm-hospital",
  FAQ: PUBLIC_ROUTE_URL + "/faq",
  PMBJBSCHEME: PUBLIC_ROUTE_URL + "/pmbjb-scheme",
  ANNUALREPORT: PUBLIC_ROUTE_URL + "/annual-report",
  FINANCEREPORT: PUBLIC_ROUTE_URL + "/finance-report",
  PHARMACISTDETAILS: PUBLIC_ROUTE_URL + "/pharma-details",
  MEDIA: PUBLIC_ROUTE_URL + "/media",
  PHARMAREGISTER: PUBLIC_ROUTE_URL + "/pharma-register",
  PACSTRAINING: PUBLIC_ROUTE_URL + "/pacs-training",
  POSTRAINING: PUBLIC_ROUTE_URL + "/pos-training",
  DOWNLOADLINK: PUBLIC_ROUTE_URL + "/download-link",
  SOFTWAREHELPLINE: PUBLIC_ROUTE_URL + "/software-helpline",
  SUGAMHELPLINE: PUBLIC_ROUTE_URL + "/sugam-helpline",
  VENDORPORTAL: PUBLIC_ROUTE_URL + "/vendor-portal",
  KENDRACOMPLAINTS: PUBLIC_ROUTE_URL + "/kendra-complaints",
  WEBINARTUTORIAL: PUBLIC_ROUTE_URL + "/webinar-tutorial",
  CONTACTUS: PUBLIC_ROUTE_URL + "/contact-us",
  SCREENRECORDER: PUBLIC_ROUTE_URL + "/screen-record",
  MESSAGEPAGE: PUBLIC_ROUTE_URL + "/message-page/:name",
  RTIACT: PUBLIC_ROUTE_URL + "/rti-act",
  APPLYSUCCESSFULY: PUBLIC_ROUTE_URL + "/apply-successfully",
  COMPLETEPAYMENT: PUBLIC_ROUTE_URL + "/payment-status",
  REZORPAYPAGE: PUBLIC_ROUTE_URL + "/rezorpay",
  TAC: PUBLIC_ROUTE_URL + "/term-and-condition",
  COPYRIGHT: PUBLIC_ROUTE_URL + "/copyright",
  FEEDBACK: PUBLIC_ROUTE_URL + "/feedback",
  HYPERLINKPOLICY: PUBLIC_ROUTE_URL + "/hyperlink-policy",
  PRIVACYPOLICY: PUBLIC_ROUTE_URL + "/privacy-policy",
  DISCLAIMER: PUBLIC_ROUTE_URL + "/disclaimer",
  ARCHIVE: PUBLIC_ROUTE_URL + "/archive",
  ARCHIVEBLACKLIST: PUBLIC_ROUTE_URL + "/blacklisted-vender",
  ARCHIVEDEBBAREDED: PUBLIC_ROUTE_URL + "/debarred-listdata",
  EBROUCHER: PUBLIC_ROUTE_URL + "/ebroucher",
  ESAMVAD: PUBLIC_ROUTE_URL + "/esamvad",
  OTHERS: PUBLIC_ROUTE_URL + "/others",
  ARCHIVETENDER: PUBLIC_ROUTE_URL + "/tenderdata",
  ARCHIVEAWARDED: PUBLIC_ROUTE_URL + "/awarded-listdata",
  ARCHIVEREVOCATION: PUBLIC_ROUTE_URL + "/revocation-list",
  GALLERY: PUBLIC_ROUTE_URL + "/archive-gallery",
  ARCHIVEDETAILS: PUBLIC_ROUTE_URL + "/archive-details",
  ARCHIVERECRUITMENT: PUBLIC_ROUTE_URL + "/recruitments",
  REPORTS: PUBLIC_ROUTE_URL + "/reports",
  FINANCIALDATA: PUBLIC_ROUTE_URL + "/financial-reportdata",
  ANNUALREPORTDATA: PUBLIC_ROUTE_URL + "/annual-reportdata",
  VERTAEDITIONS: PUBLIC_ROUTE_URL + "/varta-editions",
  TESTIMONIALS: PUBLIC_ROUTE_URL + "/testimonials",
  SITEMAP: PUBLIC_ROUTE_URL + "/sitemap",
  NEARBYPHARMA: PUBLIC_ROUTE_URL + "/near-by-pharma",
  NEARBYKENDRA: PUBLIC_ROUTE_URL + "/near-by-kendra",
  NEWSDETAIL: PUBLIC_ROUTE_URL + "/NewsDetail/:id",
  MAINGALLERY: PUBLIC_ROUTE_URL + "/gallery",
  MAINGALLERYDETAIL: PUBLIC_ROUTE_URL + "/gallery-image/:name",
  ARCHIVEGALLERYDETAIL: PUBLIC_ROUTE_URL + "/archive-gallery-image/:name",
  UserProfile: {
    DASHBOARD: PUBLIC_ROUTE_URL + "/dashboard",
    APPLICATION_FORM: PUBLIC_ROUTE_URL + "/application-form",
    APPLICATION_FORM_PRINT: PUBLIC_ROUTE_URL + "/application-print",
    ADMIN_LOGIN: PUBLIC_ROUTE_URL + "/admin-login",
    MY_APPLICATION: PUBLIC_ROUTE_URL + "/my-application",
    PAY_PAYMENT: PUBLIC_ROUTE_URL + "/payment",

  },
  ADMIN: {
    APPLICATION_FORM_PRINT: PUBLIC_ROUTE_URL + "/admin/application-print",
    ADMIN_LOGIN: PUBLIC_ROUTE_URL + "/admin/login",
    ADMIN_FORGOT: PUBLIC_ROUTE_URL + "/admin/forgot",
    REJECT_REASON_APPLICATION:
      PUBLIC_ROUTE_URL + "/admin/reject-reason-application",
    REJECT_APPLICATION: PUBLIC_ROUTE_URL + "/admin/reject-application",
    APPROVE_APPLICATION: PUBLIC_ROUTE_URL + "/admin/approve-application",
    USER_ADDED_SUCCESS: PUBLIC_ROUTE_URL + "/admin/user-added",
    JOB_ADDED_SUCCESS: PUBLIC_ROUTE_URL + "/admin/job-added",
    RESUME_PRINT: PUBLIC_ROUTE_URL + "/admin/print-data/:resumeid",
    PASSWORD_CHANGE: PUBLIC_ROUTE_URL + "/admin/change-password",
    PROFILE_CHANGE: PUBLIC_ROUTE_URL + "/admin/change-profile",
    DASHBOARD: "dashboard",
    USER_LIST: "user-list",
    RECRUITMENT_LIST: "receuitment-list",
    VIEW_RESUME: "view-resume",
    ADD_USER: "add-user",
    ADD_JOB: "add-job",
    VIEW_APPLICATION: "view-application",
    RECRUITMENT_MGMT: "recruitment-management",
    UPDATE_BANNER: "UpdateBanner",
    BANNER_LIST: "banner-list",
    UPLOAD_PHOTO: "UploadPhoto",
    IMAGE_LIST: "image-list",
    TENDER_ADMIN: "Tenderlist/:activeid",
    TENDER_ADD: "add-tender",
    TENDER_DEBARRED: "add-debarred",
    TENDER_BLACKLIST: "add-black-list",
    TENDER_AWARDED: "add-awarded-list",
    TENDER_REVOCATION: "add-revocation-list",
    ADD_PRODUCTPORTFOLIO: "AddProductPortfolio",
    LIST_PRODUCTPORTFOLIO: "product-list",
    LIST_CONTACT: "contact-list-detail",
    ADD_CONTACT: "add-contact",
    UPDATE_KENDRADATA: "UpdateKendra",
    LIST_KENDRADATA: "kendra-list",
    ADD_LOCATE_DISTRIBUTOR: "add-Locatedistributor",
    LIST_LOCATE_DISTRIBUTOR: "locator-list",
    PHARMACIST_LIST: "pharma-list",
    MANAGAMENT_LIST: "managament-list",
    ADD_MANAGAMENT: "add-managament",
    NEWS_LIST: 'news-list/:active',
    MEDIA_LIST: 'media-list/:active',
    ADD_EVENT: "add-event/:active",
    ADD_WHATS_NEW: 'add-whats-new',
    ADD_NEWS_LETTER: 'add-news-letter',
    REPORT_LIST: 'report-list/:active',
    ADD_REPORT: 'add-report/:active',
  },
};
